import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'Feedback.Title',
    defaultMessage: 'Submit feedback*'
  },
  disclaimer: {
    id: 'Feedback.Disclaimer',
    defaultMessage:
      '*Feedback submission will include your name and email.\nPlease do not include any confidential or sensitive information.'
  },
  cancel: {
    id: 'Feedback.Cancel',
    defaultMessage: 'Cancel'
  },
  submit: {
    id: 'Feedback.Submit',
    defaultMessage: 'Submit'
  }
})
